import { css } from "styled-components/macro";
import {
  darkModeBackgroundColor,
  darkModeBackgroundHoveredColor,
  darkModeBackgroundHoveredTransparentColor,
  darkModeCardBackgroundColor,
  darkModeCardBorderColor,
  darkModeDisabledTextColor,
  darkModeElementBorderColor,
  darkModeModalBackgroundColor,
  darkModeTextColor,
} from "../constants/colors";

export const DARK_MODE_CSS = css`
  &,
  .cardsWrapper {
    background: ${darkModeBackgroundColor};
  }
  .MuiPaper-root,
  .MuiPapeMuiFormLabel-root,
  .MuiInputBase-input {
    background: ${darkModeCardBackgroundColor};
  }
  .MuiTypography-root,
  .MuiFormLabel-root,
  .MuiPaper-root,
  .MuiPapeMuiFormLabel-root,
  .MuiButtonBase-root:not(.MuiSwitch-thumb),
  .MuiInputBase-root,
  .MuiInputBase-input,
  .MuiOutlinedInput-notchedOutline,
  .MuiFormHelperText-root {
    color: ${darkModeTextColor};
  }
  .MuiButton-outlined {
    border: 1px solid ${darkModeCardBorderColor};
  }
  .MuiSwitch-track {
    background: "white";
  }
  .MuiButton-root:hover,
  .MuiListItem-button:hover {
    background: ${darkModeBackgroundHoveredColor};
  }
  .MuiDivider-root {
    background: ${darkModeCardBorderColor};
  }
  .MuiTypography-root,
  .MuiButton-root,
  .MuiIconButton-root {
    &.Mui-disabled {
      color: ${darkModeDisabledTextColor};
    }
  }
  .MuiOutlinedInput-notchedOutline {
    border-color: ${darkModeCardBorderColor};
  }
  .MuiIconButton-root:hover {
    background-color: ${darkModeBackgroundHoveredColor};
  }
  [class*="NavStyles"] {
    .MuiButton-root,
    .MuiIconButton-root {
      &:hover {
        background: ${darkModeBackgroundHoveredTransparentColor};
      }
    }
  }
  fieldset.MuiOutlinedInput-notchedOutline.Mui-focused {
    color: ${darkModeElementBorderColor} !important;
    border-color: ${darkModeElementBorderColor} !important;
  }
  .MuiFormLabel-root.MuiInputLabel-outlined {
    color: ${darkModeTextColor} !important;
  }
  .MuiInputBase-root {
    &:before {
      border-bottom: 1px solid rgba(255, 255, 255, 0.42) !important;
    }
    fieldset {
      border-color: ${darkModeCardBorderColor} !important;
    }
    &:hover {
      fieldset {
        border-color: ${darkModeElementBorderColor} !important;
      }
      &:before {
        border-bottom: 2px solid rgba(255, 255, 255, 0.87) !important;
      }
    }
    .MuiSelect-icon {
      color: ${darkModeTextColor};
    }
  }
  .MuiIconButton-label svg path {
    fill: ${darkModeTextColor};
  }
  .tick,
  .machineTitle {
    color: white;
  }
  .MuiSelect-nativeInput div {
    pointer-events: none;
  }
`;

export const DARK_MODE_MUI_SELECT_PROPS = {
  MenuProps: {
    PaperProps: {
      style: {
        background: darkModeModalBackgroundColor,
        color: darkModeTextColor,
      },
    },
  },
};
